import * as lib from '../lib'
import { IFetchItems, IFetchOfferDropDown, IOfferDropDown } from '../types'

export const listOfferDropDown = async (
	filter: ReturnType<typeof lib.filterSetup>,
	sort: ReturnType<typeof lib.sortSetup>,
	skip: ReturnType<typeof lib.skipSetup>,
	take: ReturnType<typeof lib.takeSetup>,
	signal?: AbortSignal | null,
	token?: string | null,
): Promise<IFetchItems<IOfferDropDown>> => {
	const headers = lib.bearer(token)
	const method: string = 'GET'
	const params: lib.FetchOptions['params'] = {
		f: filter,
		s: sort,
		skip,
		take,
	}
	const uri: string = 'offer/drop-down'

	const options: lib.FetchOptions = {
		headers,
		method,
		params,
		signal,
	}
	const data = await lib.fetching<IFetchItems<IFetchOfferDropDown>>(uri, options)

	const rows = data?.items
		?.map((item: IFetchOfferDropDown): IOfferDropDown => {
			return {
				id: item.id,
				name: item.name ?? '?',
				group: item.group ?? '?',
			}
		})

	return {
		items: rows ?? [],
		total: data?.total ?? 0,
	}
}
